import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { useQuery, QueryFunctionContext } from '@tanstack/react-query';
import { CaretDown, User } from 'phosphor-react';
import { useUsers } from '../../../../hooks/useUsers';

interface ResponsavelPickerProps {
  nomeAtual?: string | null;
  // eslint-disable-next-line no-unused-vars
  onSelect: (userId: number, nome: string) => void;
}

// Seletor de 1 responsável (busca + lista), reusando a lista de usuários do sistema
// (`useUsers`). Grava um `responsavel_id` PRÓPRIO no processo — não a associação
// usuário↔card do kanban (que restringiria a visibilidade do card).
export const ResponsavelPicker: React.FC<ResponsavelPickerProps> = ({ nomeAtual, onSelect }) => {
  const { getUsers } = useUsers();
  const [inputBusca, setInputBusca] = useState('');
  const [busca, setBusca] = useState('');

  useEffect(() => {
    const t = setTimeout(() => setBusca(inputBusca), 300);
    return () => clearTimeout(t);
  }, [inputBusca]);

  const { data: usuarios = [] } = useQuery<{ id: number; nome: string }[]>({
    queryKey: ['responsavel-picker', busca],
    queryFn: async () => {
      const ctx = {
        queryKey: ['users', { page: 1, size: 30, search: busca }],
      } as unknown as QueryFunctionContext;
      const res = await getUsers(ctx);
      return res.data.items.map(u => ({ id: u.id as number, nome: (u.nome ?? '') as string }));
    },
  });

  return (
    <Menu placement="bottom-end" isLazy>
      <MenuButton
        as={Button}
        size="xs"
        variant="ghost"
        leftIcon={nomeAtual ? <Avatar size="2xs" name={nomeAtual} /> : <User size={14} />}
        rightIcon={<CaretDown size={10} />}
        fontWeight="500"
        color="gray.600"
      >
        {nomeAtual ?? 'Atribuir responsável'}
      </MenuButton>
      <MenuList maxH="280px" overflowY="auto" minW="240px">
        <Box px={2} pb={2}>
          <Input
            size="sm"
            fontSize="13px"
            placeholder="Buscar usuário..."
            value={inputBusca}
            onChange={e => setInputBusca(e.target.value)}
            autoFocus
          />
        </Box>
        {usuarios.length === 0 ? (
          <Text px={3} py={2} fontSize="11px" color="gray.400">
            Nenhum usuário
          </Text>
        ) : (
          usuarios.map(u => (
            <MenuItem key={u.id} onClick={() => onSelect(u.id, u.nome)} fontSize="13px">
              <Avatar size="xs" name={u.nome} mr={2} />
              {u.nome}
            </MenuItem>
          ))
        )}
      </MenuList>
    </Menu>
  );
};

export default ResponsavelPicker;
